import { Navigate } from "react-router-dom";
import { usePermissions } from "../../contexts/PermissionContext";
import { useStateContext } from "../../contexts/ContextProvider";
import { defaultRouteOrder, routePermissions } from "../../config/routePermissions";

/**
 * Composant de redirection intelligente.
 * Redirige l'utilisateur vers la première page accessible selon ses permissions.
 * Utilisé pour la route racine "/" après le login.
 */
export default function SmartRedirect() {
    const { hasPermission, hasAnyPermission, isSuperAdmin } = usePermissions();
    const { isUserLoading, user } = useStateContext();

    // Attendre que l'utilisateur soit chargé
    if (isUserLoading || user.id === 0) {
        return null;
    }

    // Super admin : arrivée sur le Tableau de bord, demandée par P&W (retours V1, 9.1.3)
    if (isSuperAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    // Un hôtelier n'a aucune des permissions listées plus bas : sans cette
    // branche il finirait sur /settings, qui lui est refusé.
    if (user.is_hotelier) {
        return <Navigate to="/espace" replace />;
    }

    // Parcourir les routes dans l'ordre de priorité
    for (const route of defaultRouteOrder) {
        const perm = routePermissions[route];

        // Pas de permission requise, route accessible
        if (perm === undefined) {
            return <Navigate to={route} replace />;
        }

        // Route réservée super-admin, skip
        if (perm === null) {
            continue;
        }

        // Vérifier la permission
        const hasAccess = Array.isArray(perm)
            ? hasAnyPermission(perm)
            : hasPermission(perm);

        if (hasAccess) {
            return <Navigate to={route} replace />;
        }
    }

    // Fallback vers settings
    return <Navigate to="/settings" replace />;
}
